import { defineStore } from 'pinia';
import { router } from '@/router';
import { showSuccessToast } from 'vant';
import {
  loginApi,
  getUserinfo,
  logoutApi,
  updateTokenApi,
  sendDeleteAccountSMSApi,
  deleteAccountApi,
} from '@/api/user';
import { LoginParams } from '@/api/model/userModel';
import {
  setToken,
  setRefreshToken,
  getToken,
  deleteToken,
  setUserTabData,
  getUserTabData,
} from '@/utils/auth';
import { removeRecord, removeCurRecord } from '@/utils/storage/record';
import { deleteUserTabData } from '@/utils/auth';
interface IArchiveInfo {
  archiveId: string;
  isDemoArchive: string;
  name: string;
  gender: string;
  birthday: string;
  age: string;
  avatar: string | null;
  parentIsMyopia: string | boolean;
  correctorVisionL: string | null;
  correctorVisionR: string | null;
  rawVisionL: string | null;
  rawVisionR: string | null;
  participationDays: 10;
  vipRemainingDays: string | null;
  trainScheduleVersion: string | null;
  enableHomeTraining: boolean;
  // 整个聊天页面
  showChatPage: boolean;
  // 聊天页面的iframe
  showChatIframe: boolean;
}

export const useUserStore = defineStore({
  id: 'app-user',
  state: () => ({
    token: '',
    refreshToken: '',
    // 用户tab
    userTabData: [],
    // 档案信息
    archiveInfo: null,
    profileInfo: null,
    // 系统错误弹窗
    showSystemErrorFlag: false,
    systemErrorText:'',
    showChatPage: true,
    showChatIframe: false,
  }),
  getters: {
    hasToken(): string {
      return this.token || getToken();
    },
    getArchiveInfo(): IArchiveInfo {
      return this.archiveInfo;
    },
    getProfileInfo() {
      return this.profileInfo;
    },
    getShowChatPage(): boolean {
      return this.showChatPage;
    },
    getShowChatIframe(): boolean {
      return this.showChatIframe;
    },
  },
  actions: {
    setToken(token: string) {
      this.token = token;
      setToken(token);
    },
    setRefreshToken(token: string) {
      this.refreshToken = token;
      setRefreshToken(token);
    },
    setUserTabData(tabs: Array<String>) {
      this.userTabData = tabs;
      setUserTabData(tabs);
    },
    setArchiveInfo(data) {
      this.archiveInfo = data;
    },
    setProfileInfo(data) {
      this.profileInfo = data;
    },
    setShowSystemErrorFlag(data) {
      this.showSystemErrorFlag = data;
    },
    setSystemErrorText(data) {
      this.systemErrorText = data;
    },
    async _getUserTabData(archiveId) {
      const data = await this.getUserinfoAction(archiveId);
      return data.modules;
    },
    async login(params: LoginParams) {
      try {
        const { data } = await loginApi(params);
        if (data?.accessToken) {
          const token = `${data?.tokenHead} ${data?.accessToken}`;
          this.setToken(token);
          this.setRefreshToken(data.refreshToken);
          return this.getUserinfoAction();
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async logout() {
      try {
        await logoutApi();
        this.token = '';
        deleteToken();
        removeCurRecord();
        removeRecord();
        deleteUserTabData();
        showSuccessToast('退出登录成功');
        router.push('/login');
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async sendDeleteAccountSMS() {
      try {
        const { data } = await sendDeleteAccountSMSApi(this.profileInfo?.userId);
        if (data) return data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteAccount(code) {
      try {
        const { errorCode } = await deleteAccountApi(code);
        if (errorCode === 0) {
          this.logout();
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getUserinfoAction(archiveId = '') {
      if (!this.hasToken) return null;
      const { data } = await getUserinfo(archiveId);
      this.setUserTabData(data.modules);
      this.setArchiveInfo(data.archiveInfo);
      this.setProfileInfo(data);
      return data;
    },
    async updateToken() {
      try {
        const { data } = await updateTokenApi();
        if (data?.accessToken) {
          const token = `${data?.tokenHead} ${data?.accessToken}`;
          this.setToken(token);
          this.setRefreshToken(data.refreshToken);
          return this.getUserinfoAction();
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    changeShowChatPage(status: boolean) {
      this.showChatPage = status;
    },
    changeShowChatIframe(status: boolean) {
      this.showChatIframe = status;
    },
  },
});
